module.exports = __webpack_public_path__ + "static/img/关于我们配图-02.a40a559.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/关于我们配图-02.jpg
// module id = Gd/y
// module chunks = 1